import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AttachmentStateService {
  private attachSubject = new Subject<any>();
  private resetAttachSubject = new Subject<any>();
  private setAttachSubject = new Subject<any>();

  constructor() { }

  triggerAttachment(data) {
    this.attachSubject.next(data);
  }

  handleAttachment(): Observable<any> {
    return this.attachSubject.asObservable();
  }

  triggerResetAttachment(data) {
    this.resetAttachSubject.next(data);
  }

  handleResetAttachment(): Observable<any> {
    return this.resetAttachSubject.asObservable();
  }

  triggerSetAttachment(data) {
    this.setAttachSubject.next(data);
  }

  handleSetAttachment(): Observable<any> {
    return this.setAttachSubject.asObservable();
  }

}




// WEBPACK FOOTER //
// ./src/app/components/common/attachment/attachment.state.service.ts